import styles from './FeeServiceName.module.css';

interface FeeServiceNameProps {
  name: string;
}

const FeeServiceName = ({ name }: FeeServiceNameProps) => {
  const parts = name.split('-');
  return (
    <span>
      {parts.map((part, index) => (
        <span
          key={index}
          className={`${styles.feeName} ${styles[`feeNamePart${index + 1}`]}`}
        >
          {part}
        </span>
      )).reduce((prev, curr) => (
        <>{prev}.{curr}</>
      ))}
    </span>
  );
};

export default FeeServiceName;
